var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sections',{attrs:{"titles":_vm.titles},on:{"changeSection":function (index) { return this$1.activeSection = index; }}},[_c('Information',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeSection == 0),expression:"activeSection == 0"}],attrs:{"data":_vm.userProfileData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }